import { Button } from '@mui/material';

type SearchRemoverProps = {
    onSearch: (defaultValue: any) => void;
    defaultValue: any;
    additionalAction?: any;
};

const SearchRemover = ({
    onSearch,
    defaultValue,
    additionalAction,
}: SearchRemoverProps) => {
    const handleOnSubmit = () => {
        onSearch(defaultValue);
        additionalAction && additionalAction();
    };

    return (
        <Button
            variant="outlined"
            onClick={handleOnSubmit}
            startIcon={<i className="fa-light fa-filter-circle-xmark" />}
            color="error"
            sx={{ minWidth: 0 }}
        >
            حذف فیلتر
        </Button>
    );
};

export default SearchRemover;
